import { toast } from "react-toastify";
import { SelectSiteID } from "../../../../../../../modules/admin/configuracion/SiteID/SelectSiteID";
import { BasicButton } from "../../../../../../../modules/theme/Component/BasicButton";
import { DepartamentCitiesEditor } from "./DepartamentCitiesEditor";

interface PersonalReferenceTabProps {
    props: any;
    setProps: Function;
    missingFields: string[];
    setMissingFields: Function;
    updateAffiliate: Function;
    cannotEdit?:Boolean;
}

export const PersonalReferenceTab = ({
    props,
    setProps,
    cannotEdit,
    setMissingFields,
    updateAffiliate
}: PersonalReferenceTabProps) => {

    const validateForm = () => {
        const requiredFields: string[] = [];
        const missing = requiredFields.filter(field => !props[field]);
        setMissingFields(missing);
        return missing.length;
    };

    const handleSave = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
        } else {
            updateAffiliate();
        }
    };

    return (
        <div className="row">
            <h4>Referencia Personal:</h4>
            <div className="col-md-12">
                <label>Nombres y Apellidos:</label>
                <input
                    type="text"
                    className="form-control"
                    value={props.RefPNames}
                    onChange={(e) => setProps({ ...props, "RefPNames": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Celular:</label>
                <input
                    type="tel"
                    className="form-control"
                    value={props.RPCel}
                    onChange={(e) => setProps({ ...props, "RPCel": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Dirección:</label>
                <input
                    type="text"
                    className="form-control"
                    value={props.RPAddres}
                    onChange={(e) => setProps({ ...props, "RPAddres": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Barrio:</label>
                <input
                    type="text"
                    className="form-control"
                    value={props.RPNeighborhood}
                    onChange={(e) => setProps({ ...props, "RPNeighborhood": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Ciudad:</label>
                <DepartamentCitiesEditor idSelector={props.RPCity} onChange={(e) => { setProps({ ...props, "RPCity": e.IDCities }) }} label=" " />
            </div>

            <hr className="mt-4" />
            <h4>Referencia Familiar:</h4>
            <div className="col-md-12">
                <label>Nombres y Apellidos:</label>
                <input
                    type="text"
                    className="form-control"
                    value={props.RFNames}
                    onChange={(e) => setProps({ ...props, "RFNames": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Celular:</label>
                <input
                    type="tel"
                    className="form-control"
                    value={props.RFCel}
                    onChange={(e) => setProps({ ...props, "RFCel": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Dirección:</label>
                <input
                    type="text"
                    className="form-control"
                    value={props.RFAddres}
                    onChange={(e) => setProps({ ...props, "RFAddres": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Barrio:</label>
                <input
                    type="text"
                    className="form-control"
                    value={props.RFNeighborhood}
                    onChange={(e) => setProps({ ...props, "RFNeighborhood": e.target.value })}
                />
            </div>
            <div className="col-lg-4">
                <label>Ciudad:</label>
                <DepartamentCitiesEditor idSelector={props.RFCity} onChange={(e) => { setProps({ ...props, "RFCity": e.IDCities }) }} label=" " />
            </div>
            <div className="col-lg-4">
                <label>Parentesco:</label>
                <input
                    type="text"
                    className="form-control"
                    value={props.RFRelationship}
                    onChange={(e) => setProps({ ...props, "RFRelationship": e.target.value })}
                />
            </div>

            {!cannotEdit &&
                <div className="row mt-4">
                    <div className="col-md-12">
                        <BasicButton
                            eventClick={handleSave}
                            icon="ri-save-line"
                            children="Guardar"
                        />
                    </div>
                </div>
            }
        </div>
    );
};
